"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetTrendArrow = void 0;
var React = require("react");
var theme_1 = require("../../../utils/theme");
exports.ApWidgetTrendArrow = function (_a) {
    var trend = _a.trend, negative = _a.negative, _b = _a.isNoCriteria, isNoCriteria = _b === void 0 ? false : _b;
    if (trend === 0) {
        return null;
    }
    var trendFillCriteria = negative ? trend < 0 : trend > 0;
    var trendFillColor = trendFillCriteria ? theme_1.colors.green1 : theme_1.colors.red1;
    return (React.createElement("svg", { width: "16px", height: "20px", viewBox: "0 0 16 32", version: "1.1" },
        React.createElement("polygon", { points: "16.02 14 -8 14 -8 18 16.02 18 16.02 24 24 16 16.02 8 16.02 14", fill: isNoCriteria ? theme_1.colors.grey4 : trendFillColor, fillRule: "nonzero", transform: "translate(8, 16) " + (trend > 0 ? 'rotate(-90)' : 'rotate(90)') + " translate(-8, -16)" })));
};
//# sourceMappingURL=ApWidgetTrendArrow.js.map